import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import MidPageCTA from './components/MidPageCTA';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ProjectShowcase from './components/ProjectShowcase';
import ServiceAreasSection from './components/ServiceAreasSection';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesOverview />
        <MidPageCTA />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <ProjectShowcase />
        <ServiceAreasSection />
        <Testimonials />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
